<template>
    <!-- 企业资质 -->
    <div class="EnterpriseQualification">
        <details-head img="./img/bj2.png" title="企业资质" remarks="Enterprise qualification" />

        <TopBreadcrumb :data="[
            { label: '资质诚信' },
            { label: '企业资质' },
        ]" />

        <div class="con">
            <div class="table">
                <div class="search">
                    <el-input size="medium" v-model="form.unitName" placeholder="单位名称" style="width:250px;" clearable>
                    </el-input>
                    <el-input size="medium" v-model="form.planningQualification" placeholder="规划资质"
                        style="width:250px;" clearable></el-input>
                    <el-button size="medium" type="primary" @click="()=>{page = 1; select()}">搜索</el-button>
                </div>
                <el-table :data="tableData" style="width: 100%" v-if="isSearch">
                    <el-table-column prop="unitName" label="单位名称">
                    </el-table-column>
                    <el-table-column prop="unitNature" label="单位性质">
                    </el-table-column>
                    <el-table-column prop="planningQualification" label="规划资质">
                    </el-table-column>
                </el-table>
                <div class="pagination" v-if="isSearch">
                    <el-pagination background layout="prev, pager, next" @current-change="select" :total="total"
                        :page-size="size" :current-page.sync="page">
                    </el-pagination>
                </div>

            </div>
        </div>
    </div>
</template>
  
<script>
import TopBreadcrumb from "@/components/TopBreadcrumb.vue";
import DetailsHead from "@/components/DetailsHead.vue";
import { frontPageQuery as pageQuery } from "@/api/qualificationIntegrity.js";
export default {
    components: { DetailsHead, TopBreadcrumb },
    data() {
        return {
            total: 0,
            page: 1,
            size: 10,

            form: {
                "planningQualification": "",
                "unitName": "",
                "unitNature": "" 
            },

            tableData: [],
            isSearch:false
        };
    },
    mounted() {
        // this.select();
    },
    watch: {
    },
    methods: {
        switchPage(p) {
            this.page + p;
            if (this.page < 0) {
                this.page = 0;
            } else if (this.page > this.total / this.size) {
                this.page = this.total / this.size;
            } else {
                this.select();
            }
        },
        select() {
            this.isSearch = true;
            if(!this.form.planningQualification && !this.form.unitName){
                this.total = 0;
                this.tableData = [];
                return
            }
            pageQuery({
                page: this.page,
                size: this.size,
                ...this.form,
            }).then((res) => {
                const { data } = res;
                this.total = data.total;
                this.tableData = data.records;
                console.log(res);
            });
        },
    },
};
</script>
   
<style lang="less" scoped>
.con {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 90px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.tab {
    width: 1200px;
    height: 70px;
    background-color: rgba(247, 247, 247, 1);
    display: flex;

    .box {
        display: flex;
        justify-content: center;
        gap: 40px;
        height: 100%;
        flex: 1;

        >div {
            cursor: pointer;
            height: 70px;
            font-size: 20px;
            color: #000;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;

            &.is-select {
                color: rgba(22, 24, 228, 0.95);

                &::after {
                    content: "";
                    position: absolute;
                    top: calc(100% - 6px);
                    left: 50%;
                    transform: translateX(-50%);
                    width: 100px;
                    height: 6px;
                    border-radius: 4px;
                    background-color: rgba(84, 74, 237, 1);
                    font-weight: bold;
                }
            }
        }
    }

    .left {
        cursor: pointer;
        width: 143px;
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: rgba(0, 0, 0, 1);
        font-size: 18px;
        color: #fff;
        background-size: cover;
        background-color: rgba(22, 81, 254, 1);
        background-image: url("../../assets/icon/tab-select.png");
    }
}

.map {
    width: 100%;
    box-shadow: 0px 10px 20px 0px rgba(69, 158, 255, 0.1);
    margin-top: 54px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 31px;
    padding-bottom: 21px;

    .left {
        width: 600px;
        height: 394px;
        position: relative;

        .title {
            position: absolute;
            left: 4px;
            top: 4px;
            color: #000;
            font-size: 20px;
            font-weight: bold;
        }

        &::after {
            position: absolute;
            content: "";
            bottom: 22px;
            right: 6px;
            width: 254px;
            height: 78px;
            background-color: #fff;
        }

        >img {
            width: 555px;
            height: 394px;
        }
    }

    .right {
        height: 394px;
        width: 501px;
        background-color: rgba(247, 247, 247, 1);
        display: flex;
        justify-content: space-around;
        padding: 26px 0;
        padding-right: 26px;
        box-sizing: border-box;

        .list {
            .item {
                height: 22px;
                display: flex;
                align-items: center;
                color: rgba(16, 16, 16, 1);
                font-size: 14px;
                text-align: left;
                font-family: SourceHanSansSC-regular;

                &::before {
                    content: "";
                    margin-right: 12px;
                    width: 10px;
                    height: 10px;
                    background-color: rgba(21, 81, 254, 1);
                }
            }
        }
    }
}

.table {
    margin-top: 40px;
    width: 100%;
    box-shadow: 0px 10px 20px 0px rgba(69, 158, 255, 0.1);

    .pagination {
        padding: 50px 0;
        display: flex;
        justify-content: center;
        gap: 50px;
        align-items: center;
        font-size: 16px;
    }

    .search {
        padding: 40px 0 30px;
        display: flex;
        gap: 31px;
        justify-content: center;
    }
}
</style>
  
<style lang="less">
.EnterpriseQualification {

    .el-table__header,
    .el-table__body,
    .el-table__empty-block {
        width: 100% !important;
    }

    .has-gutter>tr,
    .has-gutter>tr .el-table__cell {
        background-color: rgba(84, 116, 248, 1);
        color: rgba(255, 255, 255, 1);
        font-size: 20px;
    }
}

.yyz::after {
    content: '1211';
    position: absolute;
    left: 100%;
    top: 0;
    height: 100%;
    display: flex;
    align-items: center;
    background-color: #fff;
}
</style>